import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as AnalyticsApi, OrcaAdminSessionsCountAvgDto, OrcaAdminSessionsCountDto, OrcaAdminSessionsCountPerDateDailyDto, OrcaAdminSessionsCountPerDateMonthlyDto, OrcaAdminSessionsCountPerDateWeeklyDto } from '@interfaces/HttpClient/AnalyticsApiModels';
import { firstValueFrom } from 'rxjs';
import { DaterangeService } from './daterange.service';

@Injectable({
	providedIn: 'root'
})
export class OrcaAdminSessionService {

	constructor(
		private analyticsApi: AnalyticsApi,
		private requestService: RequestService,
		private daterangeService: DaterangeService,
	) { }

	async getSessionsCountAsync(): Promise<OrcaAdminSessionsCountDto> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminSession_GetSessionsCount((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getSessionsCountAvgAsync(): Promise<OrcaAdminSessionsCountAvgDto> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminSession_GetSessionsCountAvg((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getSessionsCountPerDateDailyAsync(): Promise<OrcaAdminSessionsCountPerDateDailyDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminSession_GetSessionsCountPerDateDaily((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getSessionsCountPerDateWeeklyAsync(): Promise<OrcaAdminSessionsCountPerDateWeeklyDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminSession_GetSessionsCountPerDateWeekly((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getSessionsCountPerDateMonthlyAsync(): Promise<OrcaAdminSessionsCountPerDateMonthlyDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminSession_GetSessionsCountPerDateMonthly((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}
}
